// tog'a #3493 (2026-10-06): foydalanuvchi interfeys sozlamalari SERVERDA (api/UserUiPrefs) — hozircha jadval ustunlari tanlovi.
// Brauzer xotirasi (localStorage) chiqishda va sessiya tugaganda tozalanadi — tanlov yo'qolardi; endi server asosiy manba,
// brauzerdagi nusxa faqat birinchi chizish tez bo'lishi uchun. Sozlamani FAQAT foydalanuvchi o'zgartiradi (setUiPref chaqiruvi
// faqat foydalanuvchi amali bilan bo'ladi), tizim o'zi hech narsa yozmaydi.
import { request } from "./config"

const LS = "uip:"
const store = new Map<string, string>()
const listeners = new Set<() => void>()
let loadedFor = ""
let loaded = false
let loading: Promise<void> | null = null

function userKey(): string {
  try {
    const u = JSON.parse(localStorage.getItem("user") || "{}")
    return String(u?.userId ?? u?.id ?? u?.email ?? "")
  } catch {
    return ""
  }
}

function emit() {
  listeners.forEach((f) => {
    try { f() } catch {}
  })
}

/** Sozlamalar yuklanganda / o'zgarganda chaqiriladi; qaytgan funksiya obunani bekor qiladi. */
export function onUiPrefs(fn: () => void): () => void {
  listeners.add(fn)
  return () => { listeners.delete(fn) }
}

/** Serverdagi sozlamalar shu foydalanuvchi uchun yuklanganmi (eski brauzer tanlovini ko'chirish faqat shundan keyin). */
export function uiPrefsLoaded(): boolean {
  return loaded && loadedFor === userKey()
}

/** Bir marta (har foydalanuvchiga) — barcha «cols:» sozlamalari bitta so'rovda. */
export function loadUiPrefs(): Promise<void> {
  const uk = userKey()
  if (!uk) return Promise.resolve()
  if (loadedFor === uk && loading) return loading
  loadedFor = uk
  loaded = false
  store.clear()
  loading = request({ url: "UserUiPrefs", params: { prefix: "cols:" } })
    .then((r: any) => {
      if (loadedFor !== uk) return
      for (const row of r?.data || []) if (row?.key) store.set(String(row.key), String(row.value ?? ""))
      loaded = true
      emit()
    })
    .catch(() => {
      // tarmoq xatosi — keyingi jadval ochilganda qayta urinadi; brauzerdagi nusxa ishlayveradi
      if (loadedFor === uk) { loadedFor = ""; loading = null }
    })
  return loading
}

export function getUiPref(key: string): string | undefined {
  if (uiPrefsLoaded()) return store.get(key)
  try {
    const v = localStorage.getItem(LS + key)
    if (v != null) return v
  } catch {}
  return undefined
}

/** FAQAT foydalanuvchi amali bilan chaqiriladi. value = null — standartga qaytarish (sozlama o'chiriladi). */
export function setUiPref(key: string, value: string | null) {
  if (value == null) store.delete(key)
  else store.set(key, value)
  try {
    if (value == null) localStorage.removeItem(LS + key)
    else localStorage.setItem(LS + key, value)
  } catch {}
  emit()
  return request({ url: "UserUiPrefs", method: "PUT", data: { key, value } }).catch(() => {})
}

/** Kalitda faqat server qabul qiladigan belgilar qolsin (jadval nomi/marshrutdan quriladi). */
export function safePrefKey(s: string): string {
  return String(s || "").replace(/[^A-Za-z0-9_.\-|:]/g, "_").slice(0, 180)
}
